var React = require('react');

function HealthControl (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.71 24.44a9.3 9.3 0 1 0 0-18.6 9.3 9.3 0 0 0 0 18.6Z","fill":"#FFD600","key":0}),React.createElement("path",{"d":"M.898 41.16h46M39.457 22.17h4.12M18.688 15.14h4.12M39.979 11.08a9.57 9.57 0 0 0-2.86-6.73 10.12 10.12 0 0 0-14.19 0l-1.14 1h-.14l-1.15-1a10.12 10.12 0 0 0-14.19 0 9.79 9.79 0 0 0 0 13.9l15.19 14.9h.29l6.92-6.72","stroke":"#2D2D2D","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M25.409 17.74a2.61 2.61 0 1 0 .019-5.22 2.61 2.61 0 0 0-.02 5.22v0ZM36.86 24.78a2.61 2.61 0 1 0-2.61-2.61 2.6 2.6 0 0 0 2.61 2.61v0ZM28.02 15.14h15.56M18.688 22.17h15.56","stroke":"#2D2D2D","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

HealthControl.defaultProps = {"fill":"none","viewBox":"0 0 48 42"};

module.exports = HealthControl;

HealthControl.default = HealthControl;
